export enum FieldEntityType {
    ITEM,
    PROJECT,
}
